export default "__VITE_ASSET__BmCoF23f__"